import BaseStore from '@/store';
import actions from './deviationSearch.actions.js';
import mutations from './deviationSearch.mutations.js';
import state from './deviationSearch.state.js';

let store = {
	namespaced: true,
	state,
	actions,
	mutations,
};

export default store;

export function tryRegisterStoreDynamically(id) {
	let path = `deviationSearch/${id}/`;

	if (path in BaseStore._modulesNamespaceMap) {
		return false;
	}

	BaseStore.registerModule(path.slice(0, -1), store);
	return true;
}
